// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"9922eb2a","805":"3fb22142"}[chunkId] + ".chunk.css";
};